export default __webpack_public_path__ + "static/char-s-03-en-02a501165ef04731b9a2b9af38512f0d.webp";